import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { MessagesSquare, Plus, Loader2, Send } from "lucide-react";
import { api } from "../lib/api";
import { ChatRoom, ThreadRow } from "./CorrChat";

const adapter = {
  load: (tid, since) => api.portalCorrMessages(tid, since),
  send: (tid, b) => api.portalCorrSend(tid, b),
  upload: (f) => api.portalChatUpload(f),
  urlFor: (id) => api.portalFileUrl(id),
  del: (mid) => api.portalCorrDelete(mid),
};

// Employee-side WhatsApp-like chats with management/supervisors.
export const PortalChat = () => {
  const [threads, setThreads] = useState(null);
  const [active, setActive] = useState(null);
  const [newText, setNewText] = useState("");
  const [composing, setComposing] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.portalCorrThreads().then((r) => setThreads(r.items || [])).catch(() => setThreads([])), []);
  useEffect(() => { load(); const iv = setInterval(() => { if (!document.hidden) load(); }, 5000); return () => clearInterval(iv); }, [load]);
  const start = async () => {
    if (!newText.trim()) return;
    setBusy(true);
    try { const r = await api.portalCorrNew({ body: newText.trim() }); setNewText(""); setComposing(false); await load(); setActive(r.id); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الإرسال"); }
    finally { setBusy(false); }
  };
  const cur = (threads || []).find((t) => t.id === active);
  if (active) return (
    <div className="h-[calc(100dvh-190px)] min-h-[480px] overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid="portal-chat-room">
      <ChatRoom threadId={active} adapter={adapter} onBack={() => { setActive(null); load(); }} onChanged={load}
        title={cur ? (cur.direct ? cur.participants_label : cur.subject) : "…"} subtitle={cur?.org_group ? cur.participants_label : undefined} group={cur ? !cur.direct : false} />
    </div>
  );
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid="portal-chat">
      <div className="flex items-center justify-between bg-[#f0f2f5] px-3 py-2.5">
        <h3 className="font-heading font-extrabold">المراسلات</h3>
        <button onClick={() => setComposing((v) => !v)} data-testid="portal-chat-new" className="rounded-full bg-emerald-600 p-2 text-white shadow"><Plus className="h-5 w-5" /></button>
      </div>
      {composing && (
        <div className="flex items-end gap-2 border-b border-slate-100 p-3">
          <textarea data-testid="portal-chat-new-text" rows={2} value={newText} onChange={(e) => setNewText(e.target.value)} placeholder="اكتب رسالتك للإدارة…" className="flex-1 resize-none rounded-2xl bg-[#f0f2f5] px-3 py-2 text-sm outline-none" />
          <button onClick={start} disabled={busy} data-testid="portal-chat-new-send" className="flex h-11 w-11 items-center justify-center rounded-full bg-emerald-600 text-white">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-5 w-5 -scale-x-100" />}</button>
        </div>
      )}
      {threads === null ? <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>
        : threads.length === 0 ? <div className="px-6 py-12 text-center text-sm text-slate-400"><MessagesSquare className="mx-auto mb-2 h-10 w-10 text-slate-300" />لا توجد محادثات — اضغط + لمراسلة الإدارة</div>
        : threads.map((t) => <ThreadRow key={t.id} t={t} onClick={() => setActive(t.id)} />)}
    </div>
  );
};
